import { createIcon } from '@chakra-ui/react';

export const MathIcon = createIcon({
  displayName: `math`,
  viewBox: `0 0 45.341 45.5`,
  path: (
    <g transform="translate(-1074.788 441.472)">
      <rect
        width="18.606"
        height="18.606"
        rx="2.919"
        transform="translate(1076.038 -440.222)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <rect
        width="18.606"
        height="18.606"
        rx="2.919"
        transform="translate(1100.272 -440.222)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <rect
        width="18.606"
        height="18.606"
        rx="2.919"
        transform="translate(1076.038 -415.828)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <rect
        width="18.606"
        height="18.606"
        rx="2.919"
        transform="translate(1100.272 -415.828)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x2="6.03"
        y2="6.03"
        transform="translate(1082.326 -409.519)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x1="6.03"
        y2="6.03"
        transform="translate(1082.326 -409.519)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        y2="8.528"
        transform="translate(1085.341 -435.183)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x1="8.528"
        transform="translate(1081.077 -430.919)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        y2="0.438"
        transform="translate(1109.575 -410.768)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        y2="0.438"
        transform="translate(1109.575 -402.694)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x1="8.528"
        transform="translate(1105.312 -406.504)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x1="8.528"
        transform="translate(1105.705 -430.919)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
    </g>
  ),
});
